import { render, staticRenderFns } from "./layoutConfig.vue?vue&type=template&id=fbb31828&scoped=true&"
import script from "./layoutConfig.vue?vue&type=script&lang=js&"
export * from "./layoutConfig.vue?vue&type=script&lang=js&"
import style0 from "./layoutConfig.vue?vue&type=style&index=0&id=fbb31828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb31828",
  null
  
)

export default component.exports